var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitLabDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.999 220.001L165.561 106.809H90.4414L127.999 219.997V220.001Z",
    fill: "#E24329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.999 220.001L90.4413 106.809H37.8003L127.999 219.997V220.001Z",
    fill: "#FC6D26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8007 106.806L26.3827 141.206C25.3397 144.342 26.4767 147.78 29.2047 149.719L128 220.001L37.8007 106.809V106.806Z",
    fill: "#FCA326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8003 106.805H90.4413L67.8173 38.6295C66.6533 35.1235 61.5823 35.1235 60.4203 38.6295L37.8003 106.808V106.805Z",
    fill: "#E24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128 220.001L165.562 106.809H218.205L128 219.997V220.001Z",
    fill: "#FC6D26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.203 106.806L229.619 141.206C230.66 144.342 229.519 147.78 226.795 149.719L128 220.001L218.203 106.809V106.806Z",
    fill: "#FCA326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.202 106.805H165.562L188.184 38.6305C189.349 35.1245 194.419 35.1245 195.581 38.6305L218.205 106.808L218.202 106.805Z",
    fill: "#E24329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitLabDark);
export default __webpack_public_path__ + "static/media/GitLab-Dark.10cd6d8301389d3589be5420e6d4f44b.svg";
export { ForwardRef as ReactComponent };